import React, { FunctionComponent } from "react";

import { AlignItems, Divider, FlexDirection, FlexGrow, FlexWrap, Layout, SpacingSize, TemplateLayoutVariant } from "@multiweb/reactComponents";
import { IUserParticipantInformation } from "@multiweb/reactCore/workflow";
import { bemClassNames } from "@multiweb/reactUtils";
import { ParticipantType } from "@multiweb/types/multiweb";
import { IDataAttribute, RecordType } from "@multiweb/types/react";
import { Role } from "@multiweb/uiShared/Role";
import { DataRowTemplateComponentProps, getItems } from "../../../../components/DataRowTemplateComponent";
import { ParticipantsAttributes } from "../../../../types";

export type RoleUsersRowTemplateComponentProps = DataRowTemplateComponentProps & {
    record?: RecordType;
};

const classNames = bemClassNames("role-users-template-component");

export const RoleUsersRowTemplateComponent: FunctionComponent<RoleUsersRowTemplateComponentProps> = ({
    dataSourceKey,
    recordId,
    dataSourceAttributes,
    record,
}) => {
    const participantType = record?.[ParticipantsAttributes.participantType]?.value;
    const users: IDataAttribute<IUserParticipantInformation[]> | undefined = record?.[ParticipantsAttributes.roleUsers];

    if (participantType !== ParticipantType.Role || users?.value?.length === 0) {
        return null;
    }

    const attributeNames: Readonly<string[]> = [ParticipantsAttributes.roleUsers];
    const contentItems = getItems(attributeNames, dataSourceKey, recordId, dataSourceAttributes, TemplateLayoutVariant.gridParticipants, Role.rowGroup);

    return (
        <div className={classNames()}>
            <div className={classNames("divider")}>
                <Layout spacingSizeLeft={SpacingSize.l} >
                    <Divider />
                </Layout>
            </div>
            <div className={classNames("item")}>
                <Layout flexGrow={FlexGrow.one} flexWrap={FlexWrap.nowrap}>
                    <Layout
                        flexWrap={FlexWrap.nowrap}
                        flexDirection={FlexDirection.row}
                        flexGrow={FlexGrow.one}
                        alignItems={AlignItems.stretch}
                    >
                        <div className={classNames("content")}>
                            {contentItems}
                        </div>
                    </Layout>
                </Layout>
            </div>
        </div>
    );
};
